<template>

    <section>
        <b-card-body>
            <b-row>

                <!-- Frases Sga -->
                <b-col cols="12" md="12" lg="6" sm="12">

                    <b-card header="FRASES H" header-tag="header" header-class="font-weight-bold" no-body>
                        <b-card-body class="border-0 p-0">
                          <quill-editor v-model="Frases.frasesh"
                                        :toolbarOptions="toolbarOptions"/>
                        </b-card-body>
                    </b-card>

                    <b-card header="FRASES P" header-tag="header" header-class="font-weight-bold" no-body>
                        <b-card-body class="border-0 p-0">
                          <quill-editor v-model="Frases.frasesp"
                                        :toolbarOptions="toolbarOptions"/>
                        </b-card-body>
                    </b-card>

                </b-col>

                <!-- Medidas -->
                <b-col cols="12" md="12" lg="6" sm="12">

                    <div class="alert alert-warning" v-if="verifiedIfIsCurrentCompany().status">
                        <p class="m-0">
                            <i class="fa fa-info-circle mr-2"></i>
                            Recuerde editar la ET personalizada, para las empresas:
                            <ul class="m-0">
                                <li v-for="companyItem of verifiedIfIsCurrentCompany().companies" :key="companyItem.nit" v-text="companyItem.nombre"></li>
                            </ul>
                        </p>
                    </div>

                    <Pictogramas :desactivar_edicion="desactivar_edicion"/>
                    <MedidasEt v-if="!usuarioTecnico"
                                :loading="loading"
                                :idEmpresa="idEmpresa"
                    />
                </b-col>
            </b-row>

            <!-- Personalizar palabra de advertencia -->
            <b-card no-body class="mt-2 shadow-sm border-0">
                <b-card-header header-tag="header" class="p-0" role="tab">
                    <div class="bg-white px-3 py-2 cursor-pointer text-dark d-flex align-items-center justify-content-between"
                        :class="signalWord.visible ? null : 'collapsed'"
                        :aria-expanded="signalWord.visible ? 'true' : 'false'"
                        aria-controls="collapse-4"
                        @click="setSignalWord({ ...signalWord, visible: !signalWord.visible })"
                    >
                        <div class="d-flex align-items-center">
                            <i class="fa fa-info-circle"></i>
                            <strong class="ml-2">Personalizar palabra de advertencia</strong>
                        </div>
                        <i class="fa" :class="!signalWord.visible ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2" v-model="signalWord.visible">
                    <b-card-body>

                        <b-form-group id="input-group-2" label="Palabra de advertencia personalizada" label-for="input-2">
                            <b-form-select v-model="signalWord.word" :options="optionSignalWords"></b-form-select>
                        </b-form-group>

                        <div class="shadow-sm">
                            <b-alert show variant="light">
                                <div class="d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                    </svg>
                                    <strong class="ml-2">Palabra de advertencia sugerida: {{ selectedSgaCompleto.palabraSga }}</strong>
                                </div>

                            </b-alert>
                        </div>

                    </b-card-body>
                </b-collapse>
            </b-card>

            <!-- Botones del footer -->
            <b-row v-if="!desactivar_edicion">
                <b-col>
                    <Opciones :loading="loading"/>
                </b-col>
            </b-row>

        </b-card-body>

    </section>

</template>

<script>
import {mapActions, mapState, mapMutations } from 'vuex';
import QuillEditor from "@/shared/components/QuillEditor.vue";

import MedidasEt from './MedidasEt';
import Pictogramas from './Pictogramas';
import Opciones from './Opciones';

export default {
    name: 'frases-sga',
    props: ['idEmpresa', 'loading', 'desactivar_edicion'],
    components: {
        MedidasEt,
        QuillEditor,
        Pictogramas,
        Opciones
    },
    async mounted() {
        await this.getFrases();
        await this.getClasificacionSGAListas();
        await this.getPictogramas(this.$route.params.id);
        await this.getSgaCompleto(this.$route.params.id);
        await this.getInfoProductById(this.$route.params.id).then(()=>{
            this.setWordSignalWord(this.selectedProduct.custom_signal_word);
        })
        if (this.$route.params.id) await this.getAssginedCompanies(this.$route.params.id)
    },
    data() {
        return {
            configTiny: {
                plugins: 'wordcount paste',
                language_url: '/js/tiny_lang_es.js',
                height: '400px',
                content_style: 'body { font-family: Arial; user-select: none;}',
                paste_preprocess: function (plugin, args) {
                    args.content = '';
                },
                max_height: 500,
                entity_encoding : "raw",
                menubar: false,
                toolbar: 'alignleft aligncenter alignright alignjustify'
            },
            // Opciones para las palabras de advertencia
            optionSignalWords: [
                { value: null, text: '' },
                { value: 'SIN PALABRA DE ADVERTENCIA', text: 'SIN PALABRA DE ADVERTENCIA' },
                { value: 'PELIGRO', text: 'PELIGRO' },
                { value: 'ATENCIÓN', text: 'ATENCIÓN' },
                { value: 'NO APLICA', text: 'NO APLICA' },
            ],
            // Empresa: HALLIBURTON LATIN AMERICA SRL SUCURSAL COLOMBIA
            companyNitBaker: "800206842",
            // Empresa: BAKER HUGHES AG COMPANY
            companyNitHalli: "860051812",
            toolbarOptions : [
              ['bold'],
              [{ 'align': [] }],
            ]
        };
    },
    computed: {
        ...mapState('sga', [
            'Frases',
            'idiomas',
            'versiones',
            'version',
            'idioma',
            'tipos',
            'tipo',
            'filtro',
            'signalWord'
        ]),
        ...mapState('productos', ['empresas','selectedProduct']),
        ...mapState('autenticacion', [
            'usuarioTecnico',
        ]),
        ...mapState('sgacompleto', ['selectedSgaCompleto']),
        // Estados del modulo de asignados de productos
        ...mapState('asignacionproductos', {
            assginedCompanies: 'selectedBuscaEmpr'
        }),
        editorApiKey() {
            return process.env.VUE_APP_TINY_EDITOR_KEY;
        }
    },
    methods:{
        ...mapActions('sga', ['getFrases', 'getPictogramas']),
        ...mapActions('sgacompleto', ['getClasificacionSGAListas', 'getSgaCompleto']),
        // Acciones del modulo de asignados de productos
        ...mapActions('asignacionproductos', {
            getAssginedCompanies: 'getInfoAsignacion'
        }),
        ...mapActions('productos', ['getInfoProductById']),
        ...mapMutations('sga', ['setSignalWord','setWordSignalWord']),
        /**
         * Verifica las empresas a las cuales esta asignado el producto.
         *
         * Se encuentran ya sea:
         * - HALLIBURTON LATIN AMERICA SRL SUCURSAL COLOMBIA
         * - BAKER HUGHES AG COMPANY
         *
         * Para informar que deben llenar las ET-personalizadas
         *
         * @author Fernando Claros
         */
        verifiedIfIsCurrentCompany() {

            if (!this.assginedCompanies || !'asignaciones' in this.assginedCompanies || typeof this.assginedCompanies.asignaciones !== 'object') {
                return {
                    status: false,
                    companies: []
                }
            }

            const companiesToAlert = this.assginedCompanies.asignaciones.filter(company =>
                (company.nit == this.companyNitBaker || company.nit == this.companyNitHalli) &&
                company.asignado
            )

            return {
                status: (!!companiesToAlert && companiesToAlert.length > 0) ? true : false,
                companies: companiesToAlert
            }

        }
    }
};
</script>

<style scoped>
.tox-notifications-container {
    display: none !important;
}

.mce-notification {
    display: none !important;
}
</style>
